import { render, staticRenderFns } from "./topic.vue?vue&type=template&id=0b9ce78a&scoped=true"
import script from "./topic.vue?vue&type=script&lang=js"
export * from "./topic.vue?vue&type=script&lang=js"
import style0 from "./topic.vue?vue&type=style&index=0&id=0b9ce78a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9ce78a",
  null
  
)

export default component.exports